import { Pen, Tv2, Sprout, Cpu, Handshake, Banknote, LineChart } from "lucide-react";

const WORKSTREAMS = [
  {
    n: "01",
    icon: Pen,
    title: "Creative & Content Development",
    body: "Compelling storylines, challenge design, and broadcast-quality post-production that highlight the potential of modern agriculture.",
  },
  {
    n: "02",
    icon: Tv2,
    title: "Media & Broadcasting",
    body: "Global TV partnerships, social-first digital strategy, international syndication, and data-driven audience growth.",
  },
  {
    n: "03",
    icon: Sprout,
    title: "Agri-preneurship & Youth Empowerment",
    body: "Training, mentorship, funding facilitation, market linkages, and a post-show ecosystem that grows agri-preneurs for life.",
  },
  {
    n: "04",
    icon: Cpu,
    title: "Technology & Innovation",
    body: "Showcase cutting-edge agri-tech, Governor Bago AI integration, digital farming tools, and open innovation hackathons.",
  },
  {
    n: "05",
    icon: Handshake,
    title: "Partnership & Stakeholders",
    body: "Government, corporate sponsors, NGOs, academic institutions, and community/farmer groups, aligned to one mission.",
  },
  {
    n: "06",
    icon: Banknote,
    title: "Finance & Investment",
    body: "Transparent budgeting, multi-stream revenue, investor matchmaking for participants, and a path to an impact fund.",
  },
  {
    n: "07",
    icon: LineChart,
    title: "Monitoring & Impact",
    body: "Clear KPIs, robust data tracking, regular impact assessments, and feedback loops driving continuous improvement.",
  },
];

export default function Workstreams({ compact = false }) {
  return (
    <section className={compact ? "py-20" : "py-24"}>
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-14">
          <div>
            <div className="text-xs uppercase tracking-[0.3em] text-[#F26A1F] mb-3">
              How we build it
            </div>
            <h2
              className="text-4xl md:text-5xl font-bold tracking-tighter leading-[1.05]"
              style={{ fontFamily: "'Cabinet Grotesk', 'Bricolage Grotesque', sans-serif" }}
            >
              Seven workstreams.<br />
              One <span className="text-[#2BA84A]">national mission</span>.
            </h2>
          </div>
          <p className="text-sm text-white/60 max-w-md leading-relaxed">
            Every episode you see on Global TV is the output of seven coordinated
            workstreams, the operating engine that powers the Agrovest Reality TV Show.
          </p>
        </div>

        <div className="grid md:grid-cols-12 gap-3">
          {WORKSTREAMS.map((w, i) => {
            const Icon = w.icon;
            const span =
              i === 0
                ? "md:col-span-5"
                : i === 1
                ? "md:col-span-4"
                : i === 2
                ? "md:col-span-3"
                : i === 6
                ? "md:col-span-12"
                : "md:col-span-3";
            return (
              <div
                key={w.n}
                className={`${span} group relative p-7 border border-white/10 bg-black hover:border-[#F26A1F]/60 transition-colors min-h-[200px]`}
              >
                <div className="flex items-start justify-between mb-5">
                  <span
                    className="text-5xl font-black text-white/10 group-hover:text-[#F26A1F]/30 transition-colors tracking-tighter"
                    style={{ fontFamily: "'Cabinet Grotesk', 'Bricolage Grotesque', sans-serif" }}
                  >
                    {w.n}
                  </span>
                  <Icon size={20} className="text-[#2BA84A] mt-2 shrink-0" />
                </div>
                <h3
                  className="text-lg font-bold tracking-tight mb-2"
                  style={{ fontFamily: "'Cabinet Grotesk', 'Bricolage Grotesque', sans-serif" }}
                >
                  {w.title}
                </h3>
                <p className="text-sm text-white/60 leading-relaxed">{w.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
